var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog203(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_203"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_203",
    "data-name": 203,
    className: "cls-2",
    d: "M72.32,95.22C56.85,105.88,12.75,85.67,9.68,61.05,5.49,27.6,78-6.76,89.41,4.1c3.47,3.29-.6,8.92-5.7,34.17C75.67,78.11,80.69,89.46,72.32,95.22Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog203);
export default __webpack_public_path__ + "static/media/dog_203.45330a5e0981b0b1f3adb99119242fff.svg";
export { ForwardRef as ReactComponent };